import KeenSlider from "keen-slider";
import Logger from "../lib/logger";

/**
 * ThemeHeaderGlobalNav --- A class to work with the global navigation found at the top of each page within the <header> element
 * @author Vincent V. Toscano
 */
class ThemeHeaderGlobalNav {
	static EVTS = {
		NEXT: 'carousel_next',
		PREVIOUS: 'carousel_previous'
	};

	constructor() {
		// Vars
		// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
		this._name = 'THEME HEADER GLOBAL NAV';
		Logger.info(`${this._name} > init`);
		this._dom_obj = document.createElement("i");
		Logger.log(`${this._name} > loaded`);
	}

	// Logic
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	/**
	 * Get support broadcast element
	 * @returns {*}
	 */
	get bcast() {
		return this._dom_obj;
	}

	/**
	 * fire --- Fire a custom event
	 * @param el DOM element event to fire event from
	 * @param type A string representing the name of the event.
	 * @param obj Send a custom object or pass "detail", optional and defaulting to null, of any type, containing an event-dependent value associated with the event. This is available to the handler using the CustomEvent.detail property.
	 * @returns {boolean|*}
	 * @example
	 * Evts.fire(mapbox_map, Evts.ON_MAP_BLADE_NAVIGATE, {
	 *  direction: "Down",
	 *  autoplay: true
	 * })
	 */
	static fire(el, type, obj = undefined) {
		return el.dispatchEvent(new CustomEvent(type,
			obj ? {detail: obj} : null
		));
	}

	/**
	 * addHandlers --- Add event handlers for view
	 */
	addHandlers() {
		console.log(`${this._name} > addHandlers`);
	}

	addEventListener(listenerName, cb) {
		this._dom_obj.addEventListener(listenerName, cb);
	}

	dispatchEvent(event) {
		this._dom_obj.dispatchEvent(event);
	}

	/**
	 * onThemeHeaderGlobalNav --- Handle Carousel events
	 * @param evt
	 */
	onThemeHeaderGlobalNav(evt) {
		// console.log(evt);
		// if (!evt.detail) return;
		// console.log(evt)
		switch (evt.type) {
			case ThemeHeaderGlobalNav.EVTS.NEXT:
				console.log(`${this._name} > onThemeHeaderGlobalNav > ${evt.type}`);
				// this._slider.next();
				break;
			case ThemeHeaderGlobalNav.EVTS.PREVIOUS:
				console.log(`${this._name} > onThemeHeaderGlobalNav > ${evt.type}`);
				// this._slider.prev();
				break;
			default:
				console.warn(`${this._name} > onThemeHeaderGlobalNav > No matching case for = ${evt.type}`);
		}
	}

	/**
	 * next --- Advance to the next slide in the carousel
	 * @param content
	 */
	next(content) {
		ThemeHeaderGlobalNav.fire(this.bcast, ThemeHeaderGlobalNav.EVTS.NEXT, content);
	}

	/**
	 * previous --- Move to the previous slide in the carousel
	 */
	previous() {
		console.log(`${this._name} > previous`, this.bcast);
		ThemeHeaderGlobalNav.fire(this.bcast, ThemeHeaderGlobalNav.EVTS.PREVIOUS, undefined);
	}
}

export { ThemeHeaderGlobalNav };
